Namespace 'Customer.Filters'

class Customer.Filters.FoldersCardView extends Backbone.View
  template: JST['backbone/templates/customer/filters/tabs/general/folders_card']
  className: 'filter-field-container parentFolder mini-scrollbar'

  initialize: ({@initialSelectedFolder, @availableFolders}) ->

  render: ->
    @$el.html @template({availableFolders: @availableFolders})
    @_selectFolderOption()
    @

  getSelectedFolder: =>
    @$el.find('input[type="radio"][name="parent"]:checked').val()

  _selectFolderOption: ->
    @$el.find("input[type='radio'][name='parent'][value=#{@initialSelectedFolder}]").prop('checked', true)

  _keepCustomerSessionAlive: ->
    Backbone.trigger 'customerSession:keepAlive'

  updateAvailableFolders: (availableFolders) ->
    @availableFolders = availableFolders
